import { useId, useState, type ReactNode } from "react";

interface InfoHintProps {
  label: string;
  children: ReactNode;
}

export function InfoHint({ label, children }: InfoHintProps) {
  const [pinned, setPinned] = useState(false);
  const tooltipId = useId();

  return (
    <span className={`cd-info-hint${pinned ? " is-pinned" : ""}`}>
      <button
        type="button"
        className="cd-info-btn"
        aria-label={label}
        aria-expanded={pinned}
        aria-describedby={tooltipId}
        onMouseDown={(e) => e.stopPropagation()}
        onClick={(e) => {
          e.stopPropagation();
          setPinned((open) => !open);
        }}
        onBlur={(e) => {
          if (!e.currentTarget.parentElement?.contains(e.relatedTarget as Node)) {
            setPinned(false);
          }
        }}
      >
        i
      </button>
      <span id={tooltipId} role="tooltip" className="cd-info-tooltip">
        {children}
      </span>
    </span>
  );
}
